import { useEffect, useRef } from "react";
import { useGame } from "../app/GameProvider.js";

export function ConfirmDialogs() {
  const { state, dispatch } = useGame();
  const dialogRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (state.overlay !== "newRunConfirm" && state.overlay !== "abandonConfirm" && state.overlay !== "endPhaseConfirm" && state.overlay !== "skipSelectionConfirm" && state.overlay !== "skipFieldJudgmentConfirm") return;
    dialogRef.current?.focus();
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") dispatch({ type: "CLOSE_OVERLAY" });
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [state.overlay, dispatch]);

  if (state.overlay === "newRunConfirm") {
    return (
      <div className="overlay" role="presentation">
        <div ref={dialogRef} className="dialog" role="dialog" aria-modal="true" tabIndex={-1}>
          <h2>今のゲームを中断して、新しく始めますか？</h2>
          <div className="row">
            <button type="button" className="btn" onClick={() => dispatch({ type: "CLOSE_OVERLAY" })}>戻る</button>
            <button type="button" className="btn btn-primary" onClick={() => dispatch({ type: "OPEN_STAGE_SELECT" })}>はじめる</button>
          </div>
        </div>
      </div>
    );
  }

  if (state.overlay === "abandonConfirm") {
    return (
      <div className="overlay" role="presentation">
        <div ref={dialogRef} className="dialog" role="dialog" aria-modal="true" tabIndex={-1}>
          <h2>ゲームをあきらめますか？</h2>
          <p>ここまでの進行は消えます。</p>
          <div className="row">
            <button type="button" className="btn" onClick={() => dispatch({ type: "CLOSE_OVERLAY" })}>戻る</button>
            <button type="button" className="btn btn-danger" onClick={() => dispatch({ type: "ABANDON_RUN" })}>あきらめる</button>
          </div>
        </div>
      </div>
    );
  }

  if (state.overlay === "endPhaseConfirm") {
    return (
      <div className="overlay" role="presentation">
        <div ref={dialogRef} className="dialog" role="dialog" aria-modal="true" aria-labelledby="end-phase-confirm-title" tabIndex={-1}>
          <h2 id="end-phase-confirm-title">使える施策が残っています</h2>
          <p>このまま施策フェーズを終了しますか？ 未使用の施策はこのフェーズでは使えなくなります。</p>
          <div className="row">
            <button type="button" className="btn" onClick={() => dispatch({ type: "CLOSE_OVERLAY" })}>施策を確認する</button>
            <button type="button" className="btn btn-primary" onClick={() => dispatch({ type: "END_PHASE" })}>終了する</button>
          </div>
        </div>
      </div>
    );
  }

  if (state.overlay === "skipSelectionConfirm") {
    return (
      <div className="overlay" role="presentation">
        <div ref={dialogRef} className="dialog" role="dialog" aria-modal="true" aria-labelledby="skip-selection-confirm-title" tabIndex={-1}>
          <h2 id="skip-selection-confirm-title">選べるカードが残っています</h2>
          <p>カードを選ばずに、この効果の処理を終えますか？</p>
          <div className="row">
            <button type="button" className="btn" onClick={() => dispatch({ type: "CLOSE_OVERLAY" })}>カードを選ぶ</button>
            <button type="button" className="btn btn-primary" onClick={() => dispatch({ type: "SUBMIT_SELECTION" })}>選ばずに進む</button>
          </div>
        </div>
      </div>
    );
  }

  if (state.overlay === "skipFieldJudgmentConfirm") {
    return (
      <div className="overlay" role="presentation">
        <div ref={dialogRef} className="dialog" role="dialog" aria-modal="true" aria-labelledby="skip-field-judgment-confirm-title" tabIndex={-1}>
          <h2 id="skip-field-judgment-confirm-title">公開した施策を戻しますか？</h2>
          <p>この施策は今すぐ使用できます。戻すと山札の上に置かれ、この効果では使用しません。</p>
          <div className="row">
            <button type="button" className="btn" onClick={() => dispatch({ type: "CLOSE_OVERLAY" })}>使用する</button>
            <button type="button" className="btn btn-primary" onClick={() => dispatch({ type: "TOGGLE_SELECTION", value: "return" })}>戻す</button>
          </div>
        </div>
      </div>
    );
  }

  return null;
}
